import { useState, useContext } from 'react';
import { UserContext } from '../../contexts/userProvider';
import TabNavigation from '../General/TabNavigation';
import Painel from './Painel';
import ClientesAtivacao from './ClientesAtivacao';
import Destinatarios from './Destinatarios';
import Configuracao from './Configuracao';
import AuditoriaFat from './AuditoriaFat';
import Evolucao from './Evolucao';
import Spxo from './Spxo';

const Faturamento = () => {
    const { isAdmin } = useContext(UserContext);
    const [activeTab, setActiveTab] = useState('painel');
    const tabs = [
        { key: 'painel', label: 'Faturamento', icon: 'folder', content: <Painel /> },
        { key: 'evolucao', label: 'Evolução', icon: 'folder', content: <Evolucao /> },
        ...(isAdmin ? [
            { key: 'clientes', label: 'Clientes', icon: 'config', content: <ClientesAtivacao /> },
            { key: 'destinatarios', label: 'Destinatários', icon: 'config', content: <Destinatarios /> },
            { key: 'configuracao', label: 'Configuração', icon: 'config', content: <Configuracao /> },
            { key: 'auditoria', label: 'Auditoria', icon: 'folder', content: <AuditoriaFat /> },
            { key: 'spxo', label: 'SPXO', icon: 'config', content: <Spxo /> },
        ] : []),
    ];
    return (
        <div className='w-full min-h-full'>
            <TabNavigation tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} variant="default" />
        </div>
    );
};

export default Faturamento;
